import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { TealsThemeProvider, ToastProvider, type TealsTheme } from '@teals/ui-web';
import { store, useAppSelector } from './store';
import { luminaLightTheme, luminaDarkTheme, GlobalStyles } from './theme';
import App from './App';

const ThemedApp: React.FC = () => {
  const mode = useAppSelector((state) => state.theme.mode);
  const theme = mode === 'dark' ? luminaDarkTheme : luminaLightTheme;

  React.useEffect(() => {
    document.documentElement.setAttribute('data-theme', mode);
  }, [mode]);

  return (
    <TealsThemeProvider theme={theme as unknown as Partial<TealsTheme>}>
      <GlobalStyles />
      <ToastProvider>
        <App />
      </ToastProvider>
    </TealsThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <ThemedApp />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);
